type VariantOptionInfo = { name: string; value: string };
type VariantInfo = {
  id?: string | number;
  inventory_quantity: number;
  inventoryPolicy?: string;
  selectedOptions?: VariantOptionInfo[];
};
type ProductInfo = { variants: VariantInfo[] };
export type VariantCollection = { products: ProductInfo[] };

function isRealVariant(v: VariantInfo): boolean {
  return (v.selectedOptions ?? []).some((o) => o.value !== "Default Title");
}

function isInStock(v: VariantInfo, minimalStock: number): boolean {
  return v.inventoryPolicy === "CONTINUE" || v.inventory_quantity > minimalStock;
}

/**
 * A variant swap needs a variant the customer does not already own. A product
 * sold in a single size ("TU") has an in-stock real variant and still nothing
 * to swap for: offering the option there leads to a step with no selector.
 */
export function hasAlternativeVariants(
  collection: VariantCollection,
  minimalStock: number,
  currentVariantId: string,
): boolean {
  return collection.products.some((p) =>
    p.variants.some(
      (v) =>
        isRealVariant(v) &&
        isInStock(v, minimalStock) &&
        String(v.id ?? "") !== currentVariantId,
    ),
  );
}
